import mixpanel from 'mixpanel-browser';
mixpanel.init('155c019784ab639716eb7828d60964e2', {debug: true});

export function postMixpanel(event_name){
    mixpanel.track(event_name, { });
}